export const days = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];
export const seoDays = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];

export const daysByIndex: { [key: string]: string } = {
  0: 'Monday',
  1: 'Tuesday',
  2: 'Wednesday',
  3: 'Thursday',
  4: 'Friday',
  5: 'Saturday',
  6: 'Sunday',
};

export function getOperationalTime(details: { [key: string]: unknown }, dayIndex: number): string {
  const base = 'operationalTime';
  const weekday = daysByIndex[dayIndex];
  const key = `${base}${weekday}`;
  return (details[key] || details[base]) as string;
}

export function getCurrentOperationalTime(details: { [key: string]: unknown }): string {
  const base = 'operationalTime';
  const weekday = new Date().toLocaleString('en-us', { weekday: 'long' });
  const key = `${base}${weekday}`;
  return (details[key] || details[base]) as string;
}

export function getWorkingTime(time: string) {
  return time?.replace('-', 'до');
}
